import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const AustralianRulesIcon = observer(
    'AustralianRulesIcon',
    ({ className, onClick }: SvgIconPropsType): JSX.Element => {
        return (
            <SvgIcon
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='#061A32'
                xmlns='http://www.w3.org/2000/svg'
                className={className}
                onClick={onClick}
            >
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M7.07228 7.0497C10.7204 3.40161 16.831 2.04216 19.4259 3.69751C19.7194 3.88477 19.8744 4.01738 20.0949 4.28685C22.0604 6.6885 20.7407 13.1373 16.9503 16.9277C13.1577 20.7202 6.82108 22.0595 4.35593 20.1106C4.08946 19.8999 3.95568 19.7537 3.76387 19.4734C2.00144 16.8975 3.36437 10.7576 7.07228 7.0497ZM8.38902 12.1807L7.70007 11.4631C7.54458 11.3011 7.54981 11.0438 7.71177 10.8883C7.87381 10.7328 8.13111 10.738 8.28661 10.9L8.91313 11.5525L9.47898 12.142L10.3565 13.0561C10.512 13.218 10.5068 13.4754 10.3447 13.6309C10.1828 13.7864 9.92538 13.7812 9.76989 13.6192L8.95652 12.7719L8.38902 12.1807ZM9.31711 9.84601L9.90059 10.4538L10.4644 11.0411L11.387 12.0021C11.5425 12.1641 11.7998 12.1694 11.9618 12.0139C12.1238 11.8584 12.129 11.601 11.9735 11.439L11.0304 10.4566L10.4671 9.86984L9.90373 9.28296C9.74823 9.12091 9.49085 9.11567 9.32889 9.27117C9.16694 9.42667 9.16161 9.68405 9.31711 9.84601ZM11.5339 8.85366L10.9342 8.22897C10.7787 8.06701 10.784 7.80963 10.9459 7.65413C11.1079 7.49864 11.3653 7.50387 11.5208 7.66583L12.1448 8.31593L12.7089 8.90351L13.5906 9.82191C13.7461 9.98395 13.7408 10.2413 13.5789 10.3967C13.4169 10.5522 13.1595 10.547 13.004 10.385L12.0973 9.44046L11.5339 8.85366Z'
                    fill='fill'
                />
            </SvgIcon>
        );
    }
);
